<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$cloudUpload"
				start
			/>
			<translate>Upload transaction files</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<file-input
						v-model="mt940"
						hide-details
						:label="$gettext('Upload mt940 file')"
						accept=".940"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<file-input
						v-model="mt942"
						hide-details
						:label="$gettext('Upload mt942 file')"
						accept=".942"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				color="primary"
				block
				:disabled="uploading"
				@click="upload"
			>
				<translate>Upload and Process</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
	inform,
} from 'laravel-front-library';

export default {
	name: 'TransactionFileUpload',
	data () {
		return {
			mt940: [],
			mt942: [],
			uploading: false,
		};
	},


	methods: {
		/**
		 * Upload transaction files
		 *
		 * @returns {void}
		 */
		upload () {
			this.uploading = true;
			const formData = new FormData();

			formData.append('transaction_files[mt940]', (this.mt940.length > 0) ? this.mt940[0] : null);
			formData.append('transaction_files[mt942]', (this.mt942.length > 0) ? this.mt942[0] : null);
			axios.post('/bo/bankingfiles/doUploadTransactionFiles', formData)
				.then(() => {
					inform(this.$gettext('File succesfully uploaded'));
					setTimeout(() => {
						window.location.href = '/bo/transactions';
					}, 1000);
				})
				.catch((error) => {
					if (error.response.status === 400) {
						displayError(this.$gettext(error.response.data));
					} else {
						displayError('Exception while generating file, please contact administrator.');
						window.captureException(error);
					}
					this.uploading = false;
				});
		}
	}
};
</script>
